import { HelpCircle } from "lucide-react";
import React from "react";

interface HoverTipProps {
  content: string;
  iconSize?: "sm" | "md" | "lg";
  className?: string;
}

const iconSizes = {
  sm: "h-3 w-3",
  md: "h-4 w-4", 
  lg: "h-5 w-5",
};

export function HoverTip({ content, iconSize = "sm", className = "" }: HoverTipProps) {
  return (
    <div className={`relative group ${className}`}>
      <HelpCircle className={`${iconSizes[iconSize]} text-muted-foreground cursor-help`} />
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-popover text-foreground text-xs rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none select-none z-50 max-w-64 w-max shadow-lg">
        {content}
      </div>
    </div>
  );
} 